import React, { useRef, useState } from 'react';
import { Button, Icon } from '@iwoca/orion';
import { t } from '@lingui/macro';
import { IHeaderParams } from 'ag-grid-community';
import clsx from 'clsx';
import { ApplicationStatusInfo } from 'components/ApplicationStatusInfo/ApplicationStatusInfo';
import { Drawer } from 'components/Drawer/Drawer';
import { useApplicationTableState } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { APPLICATION_TABLE_KEYS } from 'utils/applications/applications.config';
import styles from './TableColumnHeader.module.css';

export const TableColumnHeader = ({
  displayName,
  showColumnMenu,
  enableMenu,
  column,
}: IHeaderParams) => {
  const [isShowingStatusDrawer, setIsShowingStatusDrawer] = useState(false);
  const refButton = useRef<HTMLButtonElement>(null);
  const { hasFilter } = useApplicationTableState();
  const tableKey = column.getColId();
  const showFilter = ![
    APPLICATION_TABLE_KEYS.company_name,
    APPLICATION_TABLE_KEYS.approval_amount,
  ].includes(tableKey as any);

  const handleStatusDrawerToggle = () => {
    setIsShowingStatusDrawer(!isShowingStatusDrawer);
  };

  const onMenuClicked = () => {
    if (refButton.current !== null && enableMenu && showFilter) {
      showColumnMenu(refButton.current);
    }
  };

  let showIndicator = false;
  Object.values(APPLICATION_TABLE_KEYS).forEach((key) => {
    if (tableKey === key && hasFilter(key)) {
      showIndicator = true;
    }
  });

  return (
    <>
      <div
        className={clsx(styles.header, styles[`column-header-${tableKey}`], {
          [styles.headerWithFilter]: enableMenu && showFilter,
        })}
        data-testid={`column-header-${tableKey}`}
      >
        {tableKey === APPLICATION_TABLE_KEYS.status ? (
          <Button
            onClick={handleStatusDrawerToggle}
            className={styles.displayName}
            variant="tertiary"
          >
            {displayName}
          </Button>
        ) : (
          <div className={styles.displayName}>{displayName}</div>
        )}

        {showFilter && (
          <button
            onClick={onMenuClicked}
            ref={refButton}
            className={styles.filterIconContainer}
          >
            {enableMenu && <Icon icon="adjust" className={styles.filterIcon} />}
            {showIndicator && <div className={styles.indicator} />}
          </button>
        )}
      </div>
      {tableKey === APPLICATION_TABLE_KEYS.status && (
        <Drawer
          title={t`Status guide`}
          show={isShowingStatusDrawer}
          onClose={handleStatusDrawerToggle}
        >
          <ApplicationStatusInfo />
        </Drawer>
      )}
    </>
  );
};
